import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import Countdown from 'react-countdown';
import { base_url } from '../../Api/Api';
import Cookies from 'universal-cookie';

const Activelottery = (props) => {

    const [state, setState] = useState({
        data: props.data, // api data
        timeStyle: false, // color background timer
        days: 0,
        hours: 0,
        minutes: 0,
        canRegister: props.data.can_register
    })

    const Days = useRef(0);
    const Hours = useRef(0);
    const Minutes = useRef(0);

    const cookies = new Cookies()

    useEffect(() => {
        if (cookies.get("api_key") == null) {
            props.history.push(`/Entrance`)
        }
    }, [])

    // Renderer callback with condition
    const timerRender = ({ days, hours, minutes, completed }) => {
        if (Days.current.innerText != undefined &&
            Hours.current.innerText != undefined &&
            Minutes.current.innerText != undefined) {
            Days.current.innerText = days
            Hours.current.innerText = (hours == 0 ? '00' : hours)
            Minutes.current.innerText = (minutes == 0 ? '00' : minutes)
        }
        if (completed) {
            return (
                <>
                    <span>00</span>
                    <span>00</span>
                    <span>0</span>
                </>
            );
        } else {
            // Render a countdown
            return <span>{days}:{hours}:{minutes}</span>;
        }
    };

    return (
        <Link
            to={`${state.data == null ? 0 : state.data.result_status ? '/Lottery/LotteryExpire' : '/Lottery/LotteryDetail'}/${state.data == null ? 0 : state.data.id}`}
            className={`lottery ${state.data.length == 0 ? '' : state.data.time_secound <= 0 ? 'expire' : ''}`}>
            <div className="title">
                <span>{props.data.title || "موضوع نامشخص"}</span>
            </div>
            {/* <div className="title status">
                <span>وضعیت شما :<b>{props.data.show_result}</b></span>
            </div> */}
            <div className="timestamp active">
                <div className="time">
                    <span ref={Minutes}>{state.minutes}</span>
                    <span>دقیقه</span>
                </div>

                <div className="time">
                    <span ref={Hours}>{state.hours}</span>
                    <span>ساعت</span>
                </div>
                <div className="time">
                    <span ref={Days}>{state.days}</span>
                    <span>روز</span>
                </div>
                <div className="cmpnt-timer">
                    {state.data == null ?
                        null
                        :
                        <Countdown
                            date={Date.now() + (state.data.time_secound * 1000)}
                            renderer={timerRender} />
                    }
                </div>
            </div>
            <Link to={`${state.data == null ? 0 : state.data.result_status ? '/Lottery/LotteryExpire' : '/Lottery/LotteryDetail'}/${state.data == null ? 0 : state.data.id}`}>مشاهده جزئیات <i className="icon-arrow-down-sign-to-navigate-fill"></i></Link>

        </Link>
    );
}

export default Activelottery;
